import { render, staticRenderFns } from "./DeleteAccountDialog.vue?vue&type=template&id=cbf1ae20&scoped=true"
import script from "./DeleteAccountDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountDialog.vue?vue&type=style&index=0&id=cbf1ae20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf1ae20",
  null
  
)

export default component.exports